"use client";

import Link from "next/link";
import { ArrowRight, Headphones, IdCard, X } from "@/components/icons";
import { buttonVariants } from "@/components/ui";
import { cn } from "@/lib/utils";
import PricingCtaSection from "@/components/ui/pricing-cta-section";
import { CONTACT_SALES_URL, FREE_TRIAL_URL } from "@/lib/constants";

interface Props {
  id: string;
  heading: React.ReactNode;
}

const PERKS = [
  { icon: IdCard, label: "KYC zum Start erforderlich" },
  { icon: X, label: "Jederzeit kündbar, ohne Vertragsstrafe" },
  { icon: Headphones, label: "Premium-Live-Support inklusive" },
];

// German clone of the shared PricingCtaSection usage — same band/layout,
// translated perks and CTA buttons ("Sign Up for Free" / "Talk to Sales").
export default function PricingCtaDe({ id, heading }: Props) {
  return (
    <PricingCtaSection
      id={id}
      heading={heading}
      perks={PERKS}
      actions={
        <>
          <Link
            href={FREE_TRIAL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className={cn(
              buttonVariants({ variant: "default", size: "lg" }),
              "light:shadow-[0_10px_28px_-8px_rgb(var(--accent-blue-deep)/0.55)]"
            )}
          >
            Kostenlos registrieren
            <ArrowRight size={16} className="ml-2" aria-hidden="true" />
          </Link>
          <Link
            href={CONTACT_SALES_URL}
            className={cn(buttonVariants({ variant: "outline", size: "lg" }))}
          >
            Vertrieb kontaktieren
          </Link>
        </>
      }
    />
  );
}
